"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ButtonUploadExcel = _interopRequireDefault(require("@/components/ButtonUploadExcel"));
var _selectStaff = _interopRequireDefault(require("./selectStaff.vue"));
var _ProjectRechargeRecordConfirm = _interopRequireDefault(require("./components/ProjectRechargeRecordConfirm.vue"));
var _componentsApi = require("@/api/componentsApi");
var _api = require("../api");
var fudouActiveApi = _interopRequireWildcard(require("@/api/fudouActiveApi.js"));
var _cardDetailApi = require("@/api/cardDetailApi");
var customerOrderApi = _interopRequireWildcard(require("@/api/customerOrderApi.js"));
var _api2 = require("@/views/marketing/coupon/api.js");
var _amount = require("@/utils/amount");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    ButtonUploadExcel: _ButtonUploadExcel.default,
    SelectStaff: _selectStaff.default,
    ProjectRechargeRecordConfirm: _ProjectRechargeRecordConfirm.default
  },
  props: {
    companies: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this = this;
    return {
      dialogFormVisible: false,
      form: {
        orderType: 1,
        // 默认为福卡充值
        cardTimeRange: [],
        // 福卡有效期
        validStartTime: '',
        validEndTime: '',
        couponPackages: [],
        // 初始化优惠券包数组为空数组
        exeType: '1',
        // 默认立即发放
        projectNumber: '',
        // 项目编号
        applicationNumber: '',
        // 申请编号
        companyId: '',
        // 公司ID
        salesPrice: 0,
        // 销售总价
        sendType: '',
        // 发卡类型
        issueQuantity: '',
        // 发放数量
        integral: '0.00',
        // 福卡面值，默认显示0.00
        totalFaceValue: 0,
        // 发放总面值
        reason: '',
        // 发放原因
        remark: '',
        // 内部备注
        innerRemark: '' // 备注
      },
      formRules: {
        issueQuantity: [{
          required: true,
          type: 'number',
          min: 1,
          message: '发放数量不能为0，请选择发放方式和员工',
          trigger: 'change'
        }],
        reason: [{
          required: true,
          message: '请输入发放原因',
          trigger: 'blur'
        }],
        orderType: [{
          required: true,
          message: '请选择订单类型',
          trigger: 'change'
        }],
        sendType: [{
          required: true,
          message: '请选择发卡类型',
          trigger: 'change'
        }],
        projectNumber: [{
          validator: function validator(rule, value, callback) {
            if (Number(_this.form.sendType) === 4 && !String(value || '').trim()) {
              callback(new Error('发卡类型为出单卡时，请输入项目编号'));
              return;
            }
            callback();
          },
          trigger: 'blur'
        }],
        integral: [{
          required: true,
          message: '请输入福卡面值',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            var integral = Number(value);
            if (Number.isNaN(integral) || integral < 0) {
              callback(new Error('请输入大于等于0的有效福卡面值'));
              return;
            }
            callback();
          },
          trigger: 'blur'
        }],
        fuCardId: [{
          required: true,
          message: '请选择福卡',
          trigger: 'change'
        }],
        packageId: [{
          required: true,
          message: '请选择权益卡包',
          trigger: 'change'
        }],
        salesPrice: [{
          required: true,
          message: '请输入销售总价',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 0,
          message: '销售总价不能小于0',
          trigger: 'blur'
        }],
        cardTimeRange: [{
          required: true,
          type: 'array',
          len: 2,
          message: '请选择完整的福卡有效期',
          trigger: 'change'
        }]
      },
      sendTypeOptions: [{
        value: 1,
        label: '测试卡'
      }, {
        value: 2,
        label: '体验卡'
      }, {
        value: 3,
        label: '内部员工卡'
      }, {
        value: 4,
        label: '出单卡'
      }, {
        value: 5,
        label: '赠送'
      }, {
        value: 7,
        label: '客户充值'
      }, {
        value: 6,
        label: '其他'
      }],
      fdata: {},
      brandOption: [],
      appOptions: [],
      // 权益卡包相关数据
      packageOptions: [],
      // 权益卡包选项
      packagePage: 1,
      // 权益卡包分页
      packageLimit: 20,
      // 每页数量
      hasMorePackages: false,
      // 是否有更多数据
      packageKeyword: '',
      // 搜索关键词
      relatedCards: [],
      // 关联的卡片
      totalDistribution: 0,
      // 总分配额度
      selectedCard: null,
      // 选中的福卡信息
      loading: false,
      // 加载状态
      // 添加配置缓存，用于存储不同卡包的配置
      packageDistributionCache: {},
      // 格式: {packageId: {cardId: distributionValue}}
      distributionWarningFlag: false,
      // 分配额度是否等于福卡面值
      submitting: false,
      // 防止重复提交标志
      // 优惠券包相关数据
      couponPackageOptions: [],
      // 优惠券包选项
      couponPackagePage: 1,
      // 当前页码
      couponPackageLimit: 20,
      // 每页数量
      couponPackageTotal: 0,
      // 总数量
      couponPackageKeyword: '',
      // 搜索关键字
      couponPackageLoading: false // 加载状态

      //发放方式上传文件数据
    };
  },
  computed: {
    // 公司选项列表
    companyOptions: function companyOptions() {
      return (this.companies || []).map(function (item) {
        return {
          id: item.id,
          name: item.name || ''
        };
      }).filter(function (item) {
        return item.name;
      });
    },
    // 判断分配额度是否超出或不足福卡面值
    isDistributionExceeded: function isDistributionExceeded() {
      var totalValue = parseFloat(this.form.integral) || 0;
      if (totalValue <= 0) return false;
      return this.totalDistribution !== totalValue;
    }
  },
  mounted: function mounted() {
    this.searchBrand('');
    this.getAppList();
    this.form.customerEmpList = [];
    this.form.issueQuantity = 0;
  },
  watch: {
    // 监听福卡面值变化
    'form.integral': function formIntegral(newValue) {
      this.calculateTotalFaceValue();
      // 当面值变化且订单类型为权益卡包时，自动平均分配
      if (this.form.orderType === 2 && this.relatedCards.length > 0) {
        this.distributeValueEvenly();
      }
    },
    // 监听发放数量变化，自动计算发放总面值
    'form.issueQuantity': {
      handler: function handler(newValue) {
        var _this2 = this;
        this.calculateTotalFaceValue();
        if (newValue > 0 && this.$refs.formRef) {
          this.$nextTick(function () {
            _this2.$refs.formRef.clearValidate('issueQuantity');
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    formatYuan: function formatYuan(value) {
      return (0, _amount.formatToYuan)(value);
    },
    open: function open(data, initialFormData) {
      var _this3 = this;
      this.fdata = data;
      this.form = {
        orderType: 1,
        // 默认为福卡充值
        cardTimeRange: [],
        validStartTime: '',
        validEndTime: '',
        couponPackages: [],
        // 初始化空的优惠券包数组
        exeType: '1',
        // 默认立即发放
        projectNumber: '',
        // 项目编号
        applicationNumber: '',
        // 申请编号
        companyId: '',
        // 公司ID
        salesPrice: 0,
        // 销售总价
        sendType: '',
        // 发卡类型
        integral: '0.00',
        // 福卡面值
        totalFaceValue: 0,
        // 发放总面值
        issueQuantity: '',
        // 发放数量
        customerEmpList: [],
        // 已选员工列表，打开时清空
        reason: '',
        // 发放原因
        remark: '',
        // 内部备注
        innerRemark: '' // 备注
      };
      if (initialFormData) {
        Object.assign(this.form, this.buildResubmitFormData(initialFormData));
      }
      if (!this.form.cardTimeRange.length) {
        this.setDefaultCardTimeRange();
      }
      this.relatedCards = [];
      this.totalDistribution = 0;
      this.selectedCard = null;
      this.dialogFormVisible = true;
      this.$nextTick(function () {
        _this3.$refs.formRef.clearValidate();
      });
      if (initialFormData && this.form.fuCardId) {
        this.loadResubmitCardOption(initialFormData);
      }

      // 初始化加载优惠券包列表
      this.searchCouponPackages(true);
    },
    buildResubmitFormData: function buildResubmitFormData(data) {
      var hasValidTimeRange = data.validStartTime && data.validEndTime;
      return {
        reason: data.reason || '',
        sendType: this.normalizeSelectValue(data.sendType),
        integral: data.integral === null || data.integral === undefined ? '0.00' : data.integral,
        fuCardId: this.normalizeSelectValue(data.fuCardId),
        companyId: this.normalizeSelectValue(data.companyId),
        projectNumber: data.projectNumber || '',
        applicationNumber: data.applicationNumber || '',
        salesPrice: Number(data.salesPrice) || 0,
        validStartTime: data.validStartTime || '',
        validEndTime: data.validEndTime || '',
        cardTimeRange: hasValidTimeRange ? [data.validStartTime, data.validEndTime] : [],
        remark: data.remark || '',
        innerRemark: data.innerRemark || ''
      };
    },
    normalizeSelectValue: function normalizeSelectValue(value) {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      var numberValue = Number(value);
      return Number.isNaN(numberValue) ? value : numberValue;
    },
    loadResubmitCardOption: function loadResubmitCardOption(data) {
      var _this4 = this;
      var keyword = data.fuCardName || String(data.fuCardId || '');
      this.searchBrand(keyword).then(function () {
        var selectedCard = _this4.brandOption.find(function (item) {
          return String(item.id) === String(_this4.form.fuCardId);
        });
        if (selectedCard) {
          _this4.selectedCard = selectedCard;
          return;
        }
        if (data.fuCardName) {
          var cardOption = {
            id: _this4.form.fuCardId,
            card_name: "".concat(data.fuCardName, "\u3010").concat(_this4.form.fuCardId, "\u3011")
          };
          _this4.brandOption.unshift(cardOption);
          _this4.selectedCard = cardOption;
        }
      });
    },
    close: function close() {
      this.form = {
        orderType: 1,
        cardTimeRange: [],
        validStartTime: '',
        validEndTime: '',
        couponPackages: [],
        // 清空优惠券包
        exeType: '1',
        projectNumber: '',
        // 项目编号
        applicationNumber: '',
        // 申请编号
        companyId: '',
        // 公司ID
        salesPrice: 0,
        // 销售总价
        sendType: '',
        // 发卡类型
        integral: '0.00',
        // 福卡面值
        totalFaceValue: 0,
        // 福卡总面额
        issueQuantity: '',
        // 发放数量
        customerEmpList: [],
        // 清空已选员工
        customerEmpType: 1,
        // 重置为全员发放
        reason: '',
        // 发放原因
        remark: '',
        // 内部备注
        innerRemark: '' // 备注
      };
      this.relatedCards = [];
      this.totalDistribution = 0;
      this.dialogFormVisible = false;
    },
    down: function () {
      var _down = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _componentsApi.excelTemplateApi)('import_emp.xlsx');
            case 1:
              res = _context.v;
              window.open(res.fileName);
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      function down() {
        return _down.apply(this, arguments);
      }
      return down;
    }(),
    onSuccess: function onSuccess(excelData) {
      console.log('excelData>>>>>>>>', excelData);
      console.log('excelData>>>>>>>>', _typeof(excelData));
      var results = excelData.results;
      var arr = results.map(function (item) {
        var values = Object.values(item);
        return {
          empName: values[0],
          phone: values[1],
          empNo: values[2],
          wechat: values[3],
          dept: values[4],
          title: values[5]
        };
      });
      this.form.customerEmpList = arr;
      this.form.issueQuantity = arr.length;
      this.$message.success('上传成功');
    },
    // 获取原始上传文件
    handleFileObject: function handleFileObject(rawFile) {
      console.log('原始文件对象:', rawFile);
      // 保存原始文件到 form 中
      this.form.uploadFile = rawFile;
    },
    update: function update(data) {
      console.log("选择用户更新成功");
      this.form.customerEmpList = data;
      this.form.issueQuantity = data.length;
    },
    // 移除已选员工
    removeSelectedStaff: function removeSelectedStaff(item) {
      this.form.customerEmpList = this.form.customerEmpList.filter(function (emp) {
        return emp.id !== item.id;
      });
      this.form.issueQuantity = this.form.customerEmpList.length;
    },
    sel: function sel() {
      this.$refs.selectStaffRef.open(this.fdata.customerId, this.fdata.integralId);
    },
    submit: function () {
      var _submit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this5 = this;
        var isFormValid, params, allocations, confirmed;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!this.submitting) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.n = 2;
              return new Promise(function (resolve) {
                _this5.$refs.formRef.validate(function (valid) {
                  return resolve(valid);
                });
              });
            case 2:
              isFormValid = _context2.v;
              if (isFormValid) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              if (this.validateForm()) {
                _context2.n = 4;
                break;
              }
              return _context2.a(2);
            case 4:
              this.submitting = true; // 设置提交状态为true

              // 构建基础参数
              params = _objectSpread(_objectSpread(_objectSpread({}, this.form), this.fdata), {}, {
                type: 1,
                customerIntegralId: this.fdata.id,
                validStartTime: this.form.validStartTime || this.form.cardTimeRange && this.form.cardTimeRange[0],
                validEndTime: this.form.validEndTime || this.form.cardTimeRange && this.form.cardTimeRange[1],
                couponPackages: this.form.couponPackages || [],
                // 确保优惠券包数据传递到后端
                projectNumber: String(this.form.projectNumber || '').trim(),
                // 添加项目编号
                applicationNumber: this.form.applicationNumber || '',
                // 添加申请编号
                companyId: this.form.companyId || '',
                // 添加公司ID
                salesPrice: this.form.salesPrice || 0,
                // 添加销售总价
                sendType: this.form.sendType || '',
                // 添加发卡类型
                issueQuantity: this.form.issueQuantity || 1,
                // 添加发放数量
                reason: this.form.reason || '',
                // 添加发放原因
                remark: this.form.remark || '',
                // 内部备注
                innerRemark: this.form.innerRemark || '' // 备注
              }); // 根据不同订单类型设置特定参数
              if (this.form.orderType === 2) {
                // 构建权益卡包的配置数据
                allocations = this.relatedCards.filter(function (card) {
                  return card.distributionValue > 0;
                }).map(function (card) {
                  return {
                    cardId: card.id,
                    cardName: card.cardName || '卡片名称',
                    beans: card.distributionValue
                  };
                });
                params.fuConfig = JSON.stringify({
                  allocations: allocations.length ? allocations : []
                });
                params.fuPackageId = this.form.packageId;
              } else if (this.form.orderType === 1) {
                // 福卡充值
                params.fuCardId = this.form.fuCardId;
              }
              params.customerEmpType = this.form.customerEmpType === 1 ? 1 : 3;
              // 保留兼容性，旧字段dueTime使用validEndTime
              params.dueTime = params.validEndTime;
              _context2.n = 5;
              return this.confirmProjectRechargeRecord(params);
            case 5:
              confirmed = _context2.v;
              if (confirmed) {
                _context2.n = 6;
                break;
              }
              this.submitting = false;
              return _context2.a(2);
            case 6:
              this.submitGrant(params);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }(),
    confirmProjectRechargeRecord: function () {
      var _confirmProjectRechargeRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(params) {
        var projectNumber;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              projectNumber = String(params.projectNumber || '').trim();
              if (!(!projectNumber || Number(params.sendType) !== 4)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, true);
            case 1:
              if (this.$refs.projectRechargeRecordConfirmRef) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2, true);
            case 2:
              return _context3.a(2, this.$refs.projectRechargeRecordConfirmRef.open({
                projectNumber: projectNumber,
                resubmitBatchId: params.resubmitBatchId
              }));
          }
        }, _callee3, this);
      }));
      function confirmProjectRechargeRecord(_x) {
        return _confirmProjectRechargeRecord.apply(this, arguments);
      }
      return confirmProjectRechargeRecord;
    }(),
    submitGrant: function submitGrant(params) {
      // 根据是否有文件选择不同的提交方式
      if (this.form.customerEmpType === 3 && this.form.uploadFile) {
        // 批量上传模式，使用 FormData
        this.submitWithFile(params);
      } else {
        // 普通 JSON 提交
        this.request(_api.integralLogSaveApi, params);
      }
    },
    // 带文件上传的提交方法
    submitWithFile: function submitWithFile(params) {
      var formData = new FormData();

      // 后端使用 @RequestPart("data") 接收 JSON 数据
      // 需要将 params 转为 JSON Blob
      var jsonBlob = new Blob([JSON.stringify(params)], {
        type: 'application/json'
      });
      formData.append('data', jsonBlob);

      // 后端使用 @RequestPart("file") 接收文件
      if (this.form.uploadFile) {
        formData.append('file', this.form.uploadFile);
      }

      // 使用文件上传 API
      this.request(_api.integralLogSaveWithFileApi, formData);
    },
    searchBrand: function searchBrand() {
      var _this6 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.brandOption = [];
      return fudouActiveApi.selectCard(keyword).then(function (res) {
        _this6.brandOption = res || [];
      });
    },
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this7 = this;
      this.throttle(function () {
        _this7.searchBrand(data);
      }, 300)();
    },
    changeBrand: function changeBrand(cardId) {
      if (!cardId) {
        this.searchBrand('');
        this.selectedCard = null;
        return;
      }

      // 查找选中的卡片并显示详情
      this.selectedCard = this.brandOption.find(function (item) {
        return item.id === cardId;
      }) || null;

      // 获取卡片详情（如果有额外信息需要查询）
      this.getCardDetail(cardId);
    },
    getAppList: function () {
      var _getAppList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return (0, _cardDetailApi.getMiniappList)();
            case 1:
              res = _context4.v;
              if (res && Array.isArray(res)) {
                this.appOptions = res.map(function (item) {
                  return {
                    id: item.id,
                    name: item.appName
                  };
                });
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t2 = _context4.v;
              this.$message.error('获取小程序列表失败');
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function getAppList() {
        return _getAppList.apply(this, arguments);
      }
      return getAppList;
    }(),
    // 发卡类型切换
    handleSendTypeChange: function handleSendTypeChange(value) {
      if (Number(value) !== 4 && this.$refs.formRef) {
        this.$refs.formRef.clearValidate('projectNumber');
      }
    },
    // 订单类型切换
    handleOrderTypeChange: function handleOrderTypeChange(value) {
      this.form.fuCardId = null;
      this.form.packageId = null;
      this.relatedCards = [];
      this.totalDistribution = 0;
      if (value === 2) {
        // 选择权益卡包类型，加载权益卡包
        this.searchPackages(true);
      } else {
        // 选择福卡充值类型，加载福卡
        this.searchBrand('');
      }

      // 不管选择哪种类型，都重新加载优惠券包列表
      this.searchCouponPackages(true);
    },
    // 发放方式切换
    handleGrantTypeChange: function () {
      var _handleGrantTypeChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(value) {
        var pageFrom, res, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              // 清空已选员工列表
              this.form.customerEmpList = [];
              this.form.issueQuantity = 0;
              console.log('发放方式切换:', value);
              if (!(value === 1)) {
                _context5.n = 5;
                break;
              }
              _context5.p = 1;
              pageFrom = {
                customerId: this.fdata.customerId,
                customerIntegralId: this.fdata.integralId
              };
              console.log('pageFrom', pageFrom);
              _context5.n = 2;
              return (0, _api.empListApi)(pageFrom);
            case 2:
              res = _context5.v;
              console.log('全员发放员工列表:', res);

              // 检查返回的数据结构
              if (res && typeof res.total === 'number') {
                this.form.issueQuantity = res.total;
              } else {
                this.form.issueQuantity = 0;
              }
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t3 = _context5.v;
              this.$message.error('获取员工列表失败');
              this.form.issueQuantity = 0;
            case 4:
              _context5.n = 6;
              break;
            case 5:
              if (value === 2) {
                // 切换到指定员工模式时，清空发放数量
                this.form.issueQuantity = 0;
                this.$message.info('请点击"选择员工"按钮选择要发放的员工');
                // 可以在这里添加指定员工的特殊逻辑
              } else if (value === 3) {
                // 切换到批量模式时，清空发放数量
                this.form.issueQuantity = 0;
                this.$message.info('请点击"上传文件"按钮上传员工Excel文件');
                // 可以在这里添加批量上传的特殊逻辑
              }
            case 6:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function handleGrantTypeChange(_x2) {
        return _handleGrantTypeChange.apply(this, arguments);
      }
      return handleGrantTypeChange;
    }(),
    // 更新福卡有效期
    updateCardTimeRange: function updateCardTimeRange(val) {
      if (val && val.length === 2) {
        this.form.validStartTime = val[0];
        this.form.validEndTime = val[1];
      } else {
        this.form.validStartTime = '';
        this.form.validEndTime = '';
      }
    },
    // 设置默认福卡有效期：当前时间至三年后
    setDefaultCardTimeRange: function setDefaultCardTimeRange() {
      var pad = function pad(number) {
        return number < 10 ? "0".concat(number) : "".concat(number);
      };
      var formatDateTime = function formatDateTime(date) {
        var year = date.getFullYear();
        var month = pad(date.getMonth() + 1);
        var day = pad(date.getDate());
        var hours = pad(date.getHours());
        var minutes = pad(date.getMinutes());
        var seconds = pad(date.getSeconds());
        return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
      };
      var startTime = new Date();
      var endTime = new Date(startTime);
      endTime.setFullYear(endTime.getFullYear() + 3);
      var validStartTime = formatDateTime(startTime);
      var validEndTime = formatDateTime(endTime);
      this.form.cardTimeRange = [validStartTime, validEndTime];
      this.form.validStartTime = validStartTime;
      this.form.validEndTime = validEndTime;
    },
    // 权益卡包相关方法
    // 搜索权益卡包
    searchPackages: function searchPackages() {
      var _this8 = this;
      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      if (refresh) {
        this.packagePage = 1;
        this.packageOptions = [];
      }
      var params = {
        page: this.packagePage,
        limit: this.packageLimit,
        keyword: this.packageKeyword,
        status: 1
      };
      this.$set(this, 'loading', true);
      console.log('开始请求权益卡包列表，参数:', params);

      // 调用API获取卡包列表
      customerOrderApi.getCardPackageList(params).then(function (res) {
        console.log('获取到权益卡包列表:', res);
        var _ref = res || {
            list: [],
            total: 0
          },
          list = _ref.list,
          total = _ref.total;
        if (refresh) {
          _this8.packageOptions = list || [];
        } else {
          _this8.packageOptions = [].concat(_toConsumableArray(_this8.packageOptions), _toConsumableArray(list || []));
        }

        // 判断是否还有更多数据
        _this8.hasMorePackages = _this8.packageOptions.length < total;
        _this8.$set(_this8, 'loading', false);

        // 执行回调
        if (typeof callback === 'function') {
          callback();
        }
      }).catch(function (err) {
        console.error('获取权益卡包列表失败:', err);
        _this8.$message.error('获取权益卡包列表失败');
        _this8.$set(_this8, 'loading', false);

        // 即使出错也执行回调
        if (typeof callback === 'function') {
          callback();
        }
      });
    },
    // 处理权益卡包搜索
    handlePackageSearch: function handlePackageSearch(keyword) {
      var _this9 = this;
      this.packageKeyword = keyword;
      this.throttle(function () {
        _this9.searchPackages(true);
      }, 300)();
    },
    // 加载更多权益卡包
    loadMorePackages: function loadMorePackages() {
      this.packagePage += 1;
      this.searchPackages(false);
    },
    // 选择权益卡包
    selectPackage: function selectPackage(packageId) {
      console.log('选择权益卡包:', packageId);
      if (!packageId) {
        this.relatedCards = [];
        this.totalDistribution = 0;
        return;
      }

      // 先保存当前配置到缓存（如果有）
      if (this.form.packageId && this.relatedCards.length > 0) {
        var currentDistribution = {};
        this.relatedCards.forEach(function (card) {
          if (card.distributionValue > 0) {
            currentDistribution[card.id] = card.distributionValue;
          }
        });

        // 只有在有分配数据时才缓存
        if (Object.keys(currentDistribution).length > 0) {
          this.packageDistributionCache[this.form.packageId] = currentDistribution;
        }
      }

      // 设置新的卡包ID
      this.form.packageId = packageId;
      this.form.fuPackageId = packageId;

      // 获取关联的卡片，应用缓存配置
      this.getRelatedCards(packageId);
    },
    // 获取关联的卡片
    getRelatedCards: function getRelatedCards(packageId) {
      var _this0 = this;
      this.$set(this, 'loading', true);
      this.relatedCards = []; // 清空现有卡片

      console.log('开始请求关联卡片，packageId:', packageId);

      // 使用setTimeout确保DOM更新
      setTimeout(function () {
        // 调用API获取关联的卡片
        customerOrderApi.getRelatedCards(packageId).then(function (res) {
          console.log('获取到关联卡片数据:', JSON.stringify(res));
          try {
            var cardsData = [];

            // 处理不同格式的API返回结果
            if (res && Array.isArray(res)) {
              cardsData = res;
            } else if (res && res.cards && Array.isArray(res.cards)) {
              cardsData = res.cards;
            } else if (res && res.data && Array.isArray(res.data)) {
              cardsData = res.data;
            } else if (res && res.list && Array.isArray(res.list)) {
              cardsData = res.list;
            } else if (_typeof(res) === 'object' && res !== null) {
              // 尝试从对象提取卡片数组
              var possibleArrays = Object.values(res).filter(function (value) {
                return Array.isArray(value);
              });
              if (possibleArrays.length > 0) {
                // 使用第一个找到的数组
                cardsData = possibleArrays[0];
              }
            }
            if (cardsData.length > 0) {
              console.log('处理的卡片数组:', cardsData);

              // 获取当前卡包的缓存配置
              var cachedDistribution = _this0.packageDistributionCache[packageId] || {};

              // 规范化卡片数据结构
              _this0.relatedCards = cardsData.map(function (card) {
                var cardId = card.id || card.cardId || card.card_id;
                return {
                  id: cardId,
                  cardId: cardId,
                  cardName: card.cardName || card.name || card.card_name || "\u5361\u7247".concat(cardId),
                  internalName: card.internalName || card.internal_name || '',
                  description: card.description || card.desc || '',
                  distributionValue: cachedDistribution[cardId] || 0
                };
              });
              console.log('处理后的卡片数据:', _this0.relatedCards);

              // 自动平均分配福卡面值（如果已设置）
              if (_this0.form.integral && parseFloat(_this0.form.integral) > 0) {
                _this0.autoDistributeValue();
              }
            } else {
              console.log('未找到有效的卡片数据');
            }
          } catch (error) {
            console.error('处理卡片数据时出错:', error);
          }
          _this0.updateTotalDistribution();
          _this0.$set(_this0, 'loading', false);
        }).catch(function (err) {
          console.error('获取关联卡片失败:', err);
          _this0.$message.error('获取卡片信息失败');
          _this0.$set(_this0, 'loading', false);
        });
      }, 100);
    },
    // 更新总分配额度
    updateTotalDistribution: function updateTotalDistribution() {
      this.totalDistribution = this.relatedCards.reduce(function (sum, card) {
        var value = parseFloat(card.distributionValue) || 0;
        return sum + parseFloat(value.toFixed(2)); // 确保两位小数精度
      }, 0);

      // 检查总额是否等于福卡面值
      var totalValue = parseFloat(this.form.integral) || 0;
      if (totalValue > 0 && this.form.orderType === 2) {
        // 总分配额度不等于福卡面值时，显示警告
        this.distributionWarningFlag = Math.abs(this.totalDistribution - totalValue) > 0.01; // 允许0.01的误差
      }

      // 更新当前卡包的缓存
      if (this.form.packageId) {
        var currentDistribution = {};
        this.relatedCards.forEach(function (card) {
          if (card.distributionValue > 0) {
            currentDistribution[card.id] = card.distributionValue;
          }
        });

        // 更新缓存
        this.packageDistributionCache[this.form.packageId] = currentDistribution;
      }
    },
    // throttle实现
    throttle: function throttle(fn, delay) {
      var timer = null;
      return function () {
        if (timer) {
          return;
        }
        var args = arguments;
        var context = this;
        timer = setTimeout(function () {
          fn.apply(context, args);
          timer = null;
        }, delay);
      };
    },
    // 获取卡片详情
    getCardDetail: function getCardDetail(cardId) {
      if (!cardId) return;

      // 可以在这里增加额外的详情查询接口调用，如果需要的话
      // 但目前brandOption已包含基本信息，可能已经足够

      // 如果需要额外API调用获取详情:
      // fudouActiveApi.getCardDetail(cardId).then(res => {
      //   if (res) {
      //     this.selectedCard = res;
      //   }
      // });
    },
    // 处理福卡面值变化
    handleIntegralChange: function handleIntegralChange() {
      // 过滤负数，不能小于0
      if (this.form.integral < 0) {
        this.form.integral = 0;
      }
      if (this.form.integral && this.relatedCards.length > 0) {
        this.autoDistributeValue();
      }
      this.updateTotalDistribution();
    },
    // 发放总面值 = 发放数量 * 福卡面值
    calculateTotalFaceValue: function calculateTotalFaceValue() {
      var quantity = parseFloat(this.form.issueQuantity) || 0;
      var integral = parseFloat(this.form.integral) || 0;
      this.form.totalFaceValue = parseFloat((quantity * integral).toFixed(2));
    },
    // 自动分配福卡面值到各卡片
    autoDistributeValue: function autoDistributeValue() {
      var totalValue = parseFloat(this.form.integral) || 0;
      var cardCount = this.relatedCards.length;
      if (cardCount === 0 || totalValue === 0) return;

      // 计算每张卡片的平均值（保留两位小数）
      var baseValue = parseFloat((totalValue / cardCount).toFixed(2));

      // 处理精度问题，计算总和和可能的余额
      var totalDistributed = 0;

      // 先给所有卡片分配基础值
      this.relatedCards.forEach(function (card, index) {
        card.distributionValue = baseValue;
        totalDistributed += baseValue;
      });

      // 处理可能的精度差，将差额加到第一张卡
      var diff = parseFloat((totalValue - totalDistributed).toFixed(2));
      if (Math.abs(diff) > 0.001 && this.relatedCards.length > 0) {
        this.relatedCards[0].distributionValue = parseFloat((this.relatedCards[0].distributionValue + diff).toFixed(2));
      }
      this.updateTotalDistribution();
    },
    // 验证表单
    validateForm: function validateForm() {
      if (this.form.integral < 0) {
        this.$message.error('福卡面值不能小于0');
        return false;
      }
      if (!this.form.sendType) {
        this.$message.error('请选择发卡类型');
        return false;
      }
      if (!this.form.cardTimeRange || this.form.cardTimeRange.length < 2) {
        this.$message.error('请设置福卡有效期');
        return false;
      }
      if (!this.form.issueQuantity || this.form.issueQuantity < 1) {
        this.$message.error('发放数量不能为0,请选择发放方式');
        return false;
      }

      // 权益卡包类型的特殊处理
      if (this.form.orderType === 2) {
        // 验证分配总额必须等于福卡面值（允许0.01的误差）
        var totalValue = parseFloat(this.form.integral) || 0;
        if (Math.abs(this.totalDistribution - totalValue) > 0.01) {
          this.$message.error('分配额度总和必须等于福卡面值');
          return false;
        }
        if (this.totalDistribution === 0) {
          this.$message.error('请至少分配一个卡片的额度');
          return false;
        }
        if (!this.form.packageId) {
          this.$message.error('请选择权益卡包');
          return false;
        }
      } else if (this.form.orderType === 1) {
        // 福卡充值特殊处理
        if (!this.form.fuCardId) {
          this.$message.error('请选择福卡');
          return false;
        }
      }
      return true;
    },
    // 处理优惠券包搜索
    handleCouponPackageSearch: function handleCouponPackageSearch(keyword) {
      var _this1 = this;
      this.couponPackageKeyword = keyword;
      this.throttle(function () {
        // 如果有关键字并且选项中已经有结果，先尝试本地过滤
        if (keyword && _this1.couponPackageOptions.length > 0) {
          // 先过滤本地选项，看是否有匹配的
          var filtered = _this1.couponPackageOptions.filter(function (item) {
            return item.packageName && item.packageName.toLowerCase().includes(keyword.toLowerCase());
          });
          // 如果本地有匹配项，不发送请求
          if (filtered.length > 0) {
            console.log('本地过滤匹配', keyword, filtered.length);
            return;
          }
        }
        _this1.searchCouponPackages(true);
      }, 300)();
    },
    // 处理优惠券包选择变更
    handleCouponPackagesChange: function handleCouponPackagesChange(value) {
      // value是元素的:value值，即couponPackageOptions中设置的item.id
      console.log('选择的优惠券包ID:', value);

      // 确保值是唯一的且为数字类型
      var uniqueValues = _toConsumableArray(new Set(value)).map(function (id) {
        return typeof id === 'string' ? parseInt(id, 10) : id;
      }).filter(Boolean);
      if (uniqueValues.length !== value.length) {
        console.warn('去重前:', value, '去重后:', uniqueValues);
      }

      // 保存ID到表单数据
      this.form.couponPackages = uniqueValues;
    },
    // 加载更多优惠券包
    loadMoreCouponPackages: function loadMoreCouponPackages() {
      this.couponPackagePage += 1;
      this.searchCouponPackages(false);
    },
    // 优惠券包相关方法 - 搜索优惠券包列表
    searchCouponPackages: function searchCouponPackages() {
      var _this10 = this;
      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (refresh) {
        this.couponPackagePage = 1;
        this.couponPackageOptions = [];
      }
      this.couponPackageLoading = true;

      // 构建请求参数
      var params = {
        page: this.couponPackagePage,
        limit: this.couponPackageLimit,
        packageName: this.couponPackageKeyword // 使用packageName作为参数名称
      };

      // 调用API获取优惠券包列表
      (0, _api2.couponPackageListApi)(params).then(function (res) {
        // 从res.data中获取数据
        var _ref2 = res || {
            list: [],
            total: 0
          },
          list = _ref2.list,
          total = _ref2.total;
        console.log('获取到的优惠券包数据:', list);

        // 确保每个couponPackage都有唯一的id
        var processedList = (list || []).map(function (item) {
          // 确保有id字段，如果没有则使用其他唯一标识符
          if (!item.id && item.packageId) {
            item.id = item.packageId;
          } else if (!item.id) {
            // 如果既没有id也没有packageId，使用packageName作为备选
            console.warn('券包缺少唯一ID:', item);
            item.id = "pkg_".concat(item.packageName);
          }
          return item;
        });
        if (refresh) {
          _this10.couponPackageOptions = processedList;
        } else {
          _this10.couponPackageOptions = [].concat(_toConsumableArray(_this10.couponPackageOptions), _toConsumableArray(processedList));
        }
        _this10.couponPackageTotal = total;
        _this10.couponPackageLoading = false;
      }).catch(function (err) {
        console.error('获取优惠券包列表失败', err);
        _this10.couponPackageLoading = false;
      });
    },
    // 添加API请求方法
    request: function () {
      var _request = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(api, params) {
        var _t4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return api(params);
            case 1:
              this.$message.success('操作成功');
              this.close();
              this.$emit('refresh');
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t4 = _context6.v;
              this.$message.error(_t4);
            case 3:
              _context6.p = 3;
              this.submitting = false; // 无论成功或失败，恢复提交状态
              return _context6.f(3);
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2, 3, 4]]);
      }));
      function request(_x3, _x4) {
        return _request.apply(this, arguments);
      }
      return request;
    }(),
    // 刷新相关卡片数据
    refreshRelatedCards: function refreshRelatedCards() {
      if (this.form.packageId) {
        this.getRelatedCards(this.form.packageId);
      }
    },
    distributeValueEvenly: function distributeValueEvenly() {
      var totalValue = parseFloat(this.form.integral) || 0;
      var cardCount = this.relatedCards.length;
      if (cardCount === 0 || totalValue === 0) return;

      // 计算每张卡片的平均值（保留两位小数）
      var baseValue = parseFloat((totalValue / cardCount).toFixed(2));

      // 处理精度问题，计算总和和可能的余额
      var totalDistributed = 0;

      // 先给所有卡片分配基础值
      this.relatedCards.forEach(function (card, index) {
        card.distributionValue = baseValue;
        totalDistributed += baseValue;
      });

      // 处理可能的精度差，将差额加到第一张卡
      var diff = parseFloat((totalValue - totalDistributed).toFixed(2));
      if (Math.abs(diff) > 0.001 && this.relatedCards.length > 0) {
        this.relatedCards[0].distributionValue = parseFloat((this.relatedCards[0].distributionValue + diff).toFixed(2));
      }
      this.updateTotalDistribution();
    }
  }
};